import React, { useEffect, useState } from 'react';
import { Routes, Route, useParams, useNavigate, useLocation } from 'react-router-dom';
import ProductView from "../productView/product-view";
import CategoryView from "../categoryView/category-view";
import Shop from "../shop/shop";
import SearchPage from "../searchPage/searchPage";
import EndingProduct from '../endingProducts/endingProducts';
import LaterListProducts from "../laterListProducts/laterListProducts";
import { Product } from "../../../classes/types/product/product";

const RouteHandler: React.FC = () => {
    const [loading, setLoading] = useState(true);
    const [products, setProducts] = useState<Product[]>([]);

    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        refreshData();
    }, [location]);

    const refreshData = () => {
        const lastSegment = window.location.href.substring(window.location.href.lastIndexOf('/') + 1);
        if (lastSegment === "shop" || lastSegment === "shop/") {
            navigate(`/shop/page/1`, { replace: true });
        }
    };

    return (
        <Routes>
            <Route path="page/:page/prodotto/:idProdotto" element={<ProductViewWrapper category="shop" products={products} />} />
            <Route path="page/:page" element={<ShopWrapper loading={loading} />} />
            <Route path="cerca/:searchInput/page/:page/prodotto/:idProdotto" element={<ProductViewWrapper category="shop" products={products} />} />
            <Route path="cerca/:searchedInput/page/:page" element={<SearchPageWrapper loading={loading} />} />
            <Route path="category/:categoryCode/page/:page/prodotto/:idProdotto" element={<ProductViewWrapper products={products} />} />
            <Route path="category/:categoryCode/page/:page" element={<CategoryViewWrapper />} />
            <Route path="ending/page/:page/prodotto/:idProdotto" element={<ProductViewWrapper category="ending" />} />
            <Route path="ending/page/:page" element={<EndingProductWrapper products={products} />} />
            <Route path="saved/page/:page/prodotto/:idProdotto" element={<ProductViewWrapper category="saved" />} />
            <Route path="saved/page/:page" element={<LaterListProductsWrapper products={products} />} />
            <Route path="home/prodotto/:idProdotto" element={<ProductViewWrapper category="home" />} />
        </Routes>
    );
};

// --- Wrappers tipizzati --- //

interface ProductViewWrapperProps {
    category?: string;
    products?: Product[];
}

const ProductViewWrapper: React.FC<ProductViewWrapperProps> = ({ category, products }) => {
    const { page, idProdotto, categoryCode } = useParams();
    console.log('ProductViewWrapper params:', { page, idProdotto, categoryCode });
    if (!idProdotto) return <div>Seleziona un prodotto</div>;
    return <ProductView productIdToDisplay={idProdotto} categoryCode={categoryCode || category} />;
};


interface ShopWrapperProps {
    loading?: boolean;
}

const ShopWrapper: React.FC<ShopWrapperProps> = ({ loading }) => {
    const { page } = useParams<{ page?: string }>();

    // Tipizza esplicitamente il componente classe
    const ShopComponent = Shop as React.ComponentType<{ page?: string; loading?: boolean }>;

    return <ShopComponent page={page} loading={loading} />;
};

interface SearchPageWrapperProps {
    loading?: boolean;
}

const SearchPageWrapper: React.FC<SearchPageWrapperProps> = ({ loading }) => {
    const { page, searchInput } = useParams<{ page?: string; searchInput?: string }>();

    // Tipizza esplicitamente il componente
    const SearchPageComponent = SearchPage as React.ComponentType<{
        page?: string;
        searchedInput?: string;
        loading?: boolean;
    }>;

    return <SearchPageComponent page={page} searchedInput={searchInput} loading={loading} />;
};


const CategoryViewWrapper: React.FC = () => {
    const { page, categoryCode } = useParams<{ page?: string; categoryCode?: string }>();
    return <CategoryView page={page} categoryCode={categoryCode} />;
};

interface EndingProductWrapperProps {
    products?: Product[];
}

const EndingProductWrapper: React.FC<EndingProductWrapperProps> = ({ products }) => {
    const { page } = useParams<{ page?: string }>();
    return <EndingProduct page={page} products={products} />;
};

interface LaterListProductsWrapperProps {
    products?: Product[];
}

const LaterListProductsWrapper: React.FC<LaterListProductsWrapperProps> = ({ products }) => {
    const { page } = useParams<{ page?: string }>();
    return <LaterListProducts page={page} products={products} />;
};

export default RouteHandler;
